import { type ReactElement, type ReactNode, Suspense } from "react";
import { HelpChromeProvider } from "./help-chrome-context";
import { HelpCustomerChat } from "./help-customer-chat";
import { HelpHeader } from "./help-header";
import { HelpSearchDialog } from "./help-search-dialog";

/** Public help-center frame: Convex-style top bar, persistent documentation sidebar, search window, chat. */
export function HelpShell({
  org_name,
  org_slug,
  logo_url,
  sidebar,
  children,
}: {
  readonly org_name: string;
  readonly org_slug: string;
  readonly logo_url: string | null;
  /** Optional persistent navigation, shown only on md+ viewports. */
  readonly sidebar?: ReactNode;
  readonly children: ReactNode;
}): ReactElement {
  return (
    <HelpChromeProvider>
      <div className="flex min-h-screen flex-col bg-background">
        <HelpHeader orgName={org_name} orgSlug={org_slug} logoUrl={logo_url} />
        <div className="mx-auto flex w-full max-w-[1536px] flex-1">
          {sidebar ? (
            <aside className="sticky top-[65px] hidden h-[calc(100vh-65px)] w-[272px] shrink-0 self-start overflow-y-auto overscroll-contain [scrollbar-gutter:stable] border-r border-border/60 bg-muted/[0.08] px-4 py-7 md:block lg:w-[304px] lg:px-5">
              {sidebar}
            </aside>
          ) : null}
          <main className="min-w-0 w-full flex-1 px-5 py-8 md:px-8 md:py-10 lg:px-12 xl:px-16">{children}</main>
        </div>
        <HelpSearchDialog orgSlug={org_slug} />
        <Suspense fallback={null}>
          <HelpCustomerChat orgSlug={org_slug} orgName={org_name} />
        </Suspense>
      </div>
    </HelpChromeProvider>
  );
}
